export const MUTATION_PAIRS_ARR = [
    { classes: ['Warrior', 'Knight'], mutation: 'Paladin' },
    { classes: ['Thief', 'Archer'], mutation: 'DarkKnight' },
    { classes: ['Priest', 'Wizard'], mutation: 'Summoner' },
    { classes: ['Monk', 'Pirate'], mutation: 'Ninja' },
    { classes: ['Seer', 'Berserker'], mutation: 'Shapeshifter' },
    { classes: ['Legionnaire', 'Scholar'], mutation: 'Bard' },
    { classes: ['Paladin', 'DarkKnight'], mutation: 'Dragoon' },
    { classes: ['Shapeshifter', 'Bard'], mutation: 'SpellBow' },
    { classes: ['Summoner', 'Ninja'], mutation: 'Sage' },
    { classes: ['Dragoon', 'Sage'], mutation: 'DreadKnight' },
]

export const GENE_TITLES_ARR = ['D', 'R1', 'R2', 'R3']

export const GENE_TYPES = {
    Classes: 0,
    SubClasses: 1,
    Professions: 2,
}

export const NETWORKS = {
    klaytn: {
        id: 'kla',
        name: 'Klaytn'
    },
    dfkchain: {
        id: 'dfk',
        name: 'DFK Chain',
    },
}

export const RARITIES_ARR = ['common', 'uncommon', 'rare', 'legendary', 'mythic']

export const Rarity = ['Common', 'Uncommon', 'Rare', 'Legendary', 'Mythic']

export const REALMS = {
    serendale: {
        id: 'SER',
        name: 'Serendale',
    },
    serendale2: {
        id: 'SER2',
        name: 'Serendale 2',
    },
    crystalvale: {
        id: 'CRY',
        name: 'Crystalvale',
    },
}
